import type { TextInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { ChangeEvent } from 'react'
import { InputFieldset } from '../inputFieldset'
import { Textarea } from '@/components/ui/textarea'

export default function TextInput(props: TextInputProps) {
  const { inputId, onChange, onBlur, onFocus, value, maxLength } = props

  function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
    const newValue = event.target.value

    if (maxLength !== undefined && newValue.length > maxLength) {
      onChange(newValue.slice(0, maxLength) || null)
      return
    }

    onChange(newValue || null)
  }

  const currentLength = value?.length ?? 0
  const characterCount =
    maxLength !== undefined
      ? `Maximum ${maxLength} characters — ${currentLength} used`
      : undefined

  const maxLengthReached =
    maxLength !== undefined && currentLength >= maxLength
      ? `Maximum ${maxLength} characters — ${maxLength} used`
      : undefined

  return (
    <InputFieldset
      {...props}
      errorMessage={maxLengthReached}
      helperText={characterCount}
    >
      <Textarea
        name={inputId}
        maxLength={maxLength}
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        value={value ?? undefined}
      />
    </InputFieldset>
  )
}
